export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant_upscale_California_restaurant_interior_with_warm_ambient_lighting_soft_golden_pendant_lights_hanging_over_linen_draped_tables_floor_to_ceiling_windows_bathed_in_golden_hour_sunlight_cream_and_terracotta_color_palette_minimalist_modern_coastal_luxury_design_refined_editorial_hospitality_photography_shallow_depth_of_field_sophisticated_serene_atmosphere&width=1920&height=1080&seq=rjb4-hero-01&orientation=landscape"
          alt="Elegant California restaurant interior"
          title="RJB4 Restaurant Group hospitality"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 text-center pt-28 pb-24">
        <p className="inline-flex items-center gap-2 text-background-50/90 uppercase tracking-[0.3em] text-xs md:text-sm">
          <span className="w-8 h-px bg-accent-400"></span>
          Restaurant &amp; Hospitality Group
          <span className="w-8 h-px bg-accent-400"></span>
        </p>

        <h1 className="mt-6 font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl text-background-50 leading-[1.05] tracking-tight">
          Hospitality With Purpose.
        </h1>

        <p className="mt-6 max-w-2xl mx-auto text-background-100/90 text-base md:text-lg font-light leading-relaxed">
          RJB4 Restaurant Group, LLC is a California-based hospitality company focused on
          restaurant operations, thoughtful guest experiences, and the pursuit of excellence
          in food and service.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm md:text-base font-medium px-8 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Get in Touch
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="#about"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm md:text-base font-medium px-8 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Learn More
          </a>
        </div>
      </div>
    </section>
  );
}